module.exports = __webpack_public_path__ + "img/qrcode.eabeb01d.png";